import { createIntersectionObserverHandler, createIntersectionObserver } from './intersectionObserver';

/**
 * Delay the import of a component until the Intersection Observer.
 *
 * @param {string} targetSelector Query selector for target
 * @param {Function} componentDynamicImport Import function to load component.
 * ex: () => import('[path]')
 * @param {Object} intersectionObserverOptions Options for the
 * IntersectionObserver constructor
 * @returns {Object} Intersection Observer created
 */
function loadComponentByIntersectionObserver(
  targetSelector,
  componentDynamicImport,
  intersectionObserverOptions = {},
) {
  createIntersectionObserver(
    targetSelector,
    createIntersectionObserverHandler({
      inCallback: (_, observer) => {
        componentDynamicImport().then((component) => {
          component.default();
          // Unobserve every target after the first import
          observer.disconnect();
        });
      },
    }),
    {
      apiOptions: intersectionObserverOptions,
    },
  );
}

export default loadComponentByIntersectionObserver;
